import { render, staticRenderFns } from "./prueba3.vue?vue&type=template&id=85758aa6&scoped=true"
import script from "./prueba3.vue?vue&type=script&lang=js"
export * from "./prueba3.vue?vue&type=script&lang=js"
import style0 from "./prueba3.vue?vue&type=style&index=0&id=85758aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85758aa6",
  null
  
)

export default component.exports